module.exports = __webpack_public_path__ + "assets/images/life_50c4e65f32d2f6ed368673c88360d328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/trophies/life.png
// module id = 186
// module chunks = 0